import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ssw/banner-splash-bg.webp'


const _withScopeId = n => (_pushScopeId("data-v-78d49d9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fl_home_slider p-0" }
const _hoisted_2 = {
  id: "carouselExampleIndicators",
  class: "carousel slide banner_slider_wrapper",
  "data-bs-ride": "carousel"
}
const _hoisted_3 = { class: "carousel-inner" }
const _hoisted_4 = {
  key: 0,
  class: "carousel-item active"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box home" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text opacity-1" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "heading_title title_2 white text-uppercase fst-italic" }, " Manufacturer of High Quality Aluminium Alloy Wheels ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "d-block w-100",
    alt: "SSW Banner Image"
  }),
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.youtube.com/embed/iuMPH9EF3ao?playlist=iuMPH9EF3ao&controls=0&autoplay=1&mute=1&playsinline=1&loop=1",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1))
const _hoisted_6 = {
  class: "d-inline-flex flex-wrap gap-2 w-100 p-2 justify-content-center",
  style: {"background-color":"black"}
}
const _hoisted_7 = {
  key: 1,
  class: "carousel-item active"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"box\" data-v-78d49d9c><div class=\"container wrapper\" data-v-78d49d9c><div class=\"text opacity-1\" data-v-78d49d9c><h1 class=\"heading_title title_2 white text-uppercase fst-italic\" data-v-78d49d9c> STAMFORD SPORT WHEELS </h1></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"SSW Banner Image\" data-v-78d49d9c><iframe src=\"https://www.youtube.com/embed/YvkQ-7EtuJ4?controls=0&amp;autoplay=1&amp;mute=1&amp;playsinline=1&amp;loop=1&amp;list=PLyyzLBhnG-ktivEPyt_sldYHdON7vRPmw\" data-v-78d49d9c></iframe></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "carousel-item active"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"box\" data-v-78d49d9c><div class=\"container wrapper\" data-v-78d49d9c><div class=\"text opacity-1\" data-v-78d49d9c><h1 class=\"heading_title title_2 white text-uppercase fst-italic\" data-v-78d49d9c> DIESEL RANGE </h1></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"SSW Banner Image\" data-v-78d49d9c><iframe src=\"https://www.youtube.com/embed/0QL_JXkUAYA?controls=0&amp;autoplay=1&amp;mute=1&amp;playsinline=1&amp;loop=1&amp;list=PLyyzLBhnG-ksO-o9I8MRW07n3et6ERdlH\" data-v-78d49d9c></iframe></div>", 1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "carousel-item active"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"box\" data-v-78d49d9c><div class=\"container wrapper\" data-v-78d49d9c><div class=\"text opacity-1\" data-v-78d49d9c><h1 class=\"heading_title title_2 white text-uppercase fst-italic\" data-v-78d49d9c> FLOTEC RANGE </h1></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"SSW Banner Image\" data-v-78d49d9c><iframe src=\"https://www.youtube.com/embed/964GSZF_nxs?si=Rp1xKI8riAJ--sJy&amp;controls=0&amp;autoplay=1&amp;mute=1&amp;playsinline=1&amp;loop=1&amp;playlist=964GSZF_nxs\" data-v-78d49d9c></iframe></div>", 1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.wheelBrandsRoute == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: { path: '/ssw-wheels' , hash: '#wheelBrands'},
                  class: "btn red_btn white_hover"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("VIEW SSW WHEELS")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { path: '/diesel-wheels' , hash: '#wheelBrands'},
                  class: "btn red_btn white_hover"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("VIEW DIESEL WHEELS")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { path: '/flotec-wheels' , hash: '#wheelBrands'},
                  class: "btn red_btn white_hover"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("VIEW FLOTEC WHEELS")
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_ctx.wheelBrandsRoute == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : (_ctx.wheelBrandsRoute == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      ])
    ])
  ]))
}